import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ParametrosService } from '../../../../../services/parametros.service';
import { Parametros } from '../../../../../models/parametros.model';
import { ErrorModel } from '../../../../../models/error.model';

@Component({
  selector: 'app-parametros-manutencao',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './parametros-manutencao.component.html',
  styleUrl: './parametros-manutencao.component.css',
})
export class ParametrosManutencaoComponent implements OnInit {
  parametro: Parametros = this.getEmpty();
  isEditMode = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private parametrosService: ParametrosService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.isEditMode = true;
      this.parametrosService.getParametroById(+id).subscribe(data => {
        this.parametro = data;
      });
    }
  }

  save(): void {
    if (this.isEditMode) {
      this.parametrosService.updateParametro(this.parametro).subscribe({
        next: () => this.navigateWithSuccess('Parâmetro atualizado com sucesso'),
        error: (error) => {
          const erro: ErrorModel = error.error;
          this.toastr.error(erro.message);
        }
      });
    } else {
      this.parametrosService.createParametro(this.parametro).subscribe({
        next: () => this.navigateWithSuccess('Parâmetro cadastrado com sucesso'),
        error: (error) => {
          const erro: ErrorModel = error.error;
          this.toastr.error(erro.message);
        }
      });
    }
  }

  cancel(): void {
    this.router.navigate(['/home', 'parametro-parametros']);
  }

  private getEmpty(): Parametros {
    return {
      id: 0,
      descricao: '',
      valorMaximo: '',
      valorMinimo: '',
      valorNumerico: '',
      categoria: ''
    };
  }

  private navigateWithSuccess(message: string): void {
    this.router.navigate(['/home', 'parametro-parametros'], {
      state: { successMessage: message }
    });
  }
}

